import * as yup from "yup";

/* eslint-disable no-template-curly-in-string */

yup.setLocale({
  mixed: {
    default: "${path} حقل غير صالح",
    required: "${path} مطلوب",
  },
  string: {
    email: "${path} يجب أن يكون عنوان بريد إلكتروني صالح",
    url: "${path} يجب أن يكون عنوان رابط صالح",
    min: "${path} يجب ان تكون ${min} أحرف على الاقل",
  },
});

// Workaround to use locale
// see: https://github.com/jquense/yup/issues/293
export default yup;
